module.exports = __webpack_public_path__ + "img/IconoPrincipal.6b0f8ac2.png";